import httpClient from '@/lib/httpClient'
import { useQuery } from '@tanstack/react-query'
import type { BillingInterval } from './useGetBillingSubscription'

export interface PlanPrice {
  /** cents */
  amount: number
  currency: string
}

export interface Plan {
  plan_key: string
  /** basic | pro — set by the backend, never derived from the plan name */
  tier: string | null
  /** false while the plan's tier is "coming soon" (no checkout / switch) */
  purchasable: boolean
  name: string
  description: string | null
  /** Plan-card copy, in display order */
  inclusions: string[]
  prices: Partial<Record<BillingInterval, PlanPrice>>
}

export default function useGetPlans({ enabled = true } = {}) {
  return useQuery<Plan[]>({
    queryKey: ['billing-plans'],
    queryFn: async () => {
      const response = await httpClient.get('billing/plans')
      return response.data
    },
    enabled,
    staleTime: 10 * 60 * 1000,
  })
}
